// src/pages/horecahub/components/KhauGaliMetaverseMarketplace.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faStarHalfAlt,
  faCheckCircle,
  faTag,
  faBowlRice,
} from "@fortawesome/free-solid-svg-icons";

const marketplaceData = {
  "Any": {
    "Street Food Stall": {
      "Current Discounts": ["Pani Puri", "Vada Pav", "Pav Bhaji", "Bhel Puri", "Chicken Roll", "Momos"],
      "Combo Meals": ["Chaat Platter", "Pav Bhaji + Lassi", "Biryani Combo", "Momos + Soup"],
      "Late Night Snacks": ["Vada Pav", "Egg Roll", "Pav Bhaji", "Momos"],
      "Breakfast": ["Idli Vada", "Poha", "Vada Pav"],
      "Lunch/Dinner": ["Pav Bhaji", "Misal Pav", "Chicken Biryani"],
    },
    "Food Cart": {
      "Current Discounts": ["Sugarcane Juice", "Corn on Cob", "Kulfi"],
      "Combo Meals": ["Chaat + Juice Combo"],
    },
    "QSR": {
      "Combo Meals": ["Burger + Fries", "Wrap Combo"],
      "Current Discounts": ["Veg Burger", "Chicken Nuggets"],
    },
    "Cafe": {
      "Brunch": ["Sandwich + Coffee", "Pasta"],
    },
  },
  "Vegetarian": {
    "Street Food Stall": {
      "Current Discounts": ["Pani Puri", "Bhel Puri", "Vada Pav", "Aloo Tikki Chaat"],
      "Combo Meals": ["Dosa + Idli Combo", "Chaat Platter", "Pav Bhaji + Falooda"],
      "Breakfast": ["Idli Vada Sambar", "Poha", "Upma"],
      "Lunch/Dinner": ["Pav Bhaji", "Chole Bhature", "Misal Pav"],
      "Desserts": ["Kulfi Falooda", "Jalebi Rabdi", "Gulab Jamun"],
    },
    "Cafe": {
      "Current Discounts": ["Veg Sandwich", "Cold Coffee", "Pastries"],
      "Brunch": ["Veg Wrap + Juice"],
    },
    "Fine-Dine": {
      "Lunch/Dinner": ["Paneer Butter Masala Thali", "Dal Makhani + Naan"],
    },
  },
  "Non-Vegetarian": {
    "Street Food Stall": {
      "Current Discounts": ["Chicken Tikka Roll", "Seekh Kebab", "Egg Bhurji Pav"],
      "Combo Meals": ["Chicken Biryani + Raita", "Shawarma Plate"],
      "Lunch/Dinner": ["Chicken Biryani", "Butter Chicken"],
      "Late Night Snacks": ["Egg Roll", "Chicken Momos"],
    },
    "QSR": {
      "Combo Meals": ["Chicken Burger + Fries", "Non-Veg Wrap"],
    },
  },
  "Jain": {
    "Street Food Stall": {
      "Current Discounts": ["Jain Pani Puri", "Jain Bhel Puri"],
      "Combo Meals": ["Jain Dosa + Chutney"],
      "Lunch/Dinner": ["Jain Pav Bhaji (No Onion/Garlic/Potato)"],
    },
  },
  "Veg & Non-Veg": {
    "Street Food Stall": {
      "Current Discounts": ["Veg Momos", "Chicken Momos", "Veg Roll", "Chicken Roll"],
      "Combo Meals": ["Mixed Chaat Platter", "Indo-Chinese Combo"],
    },
    "Food Truck": {
      "Current Discounts": ["Veg Shawarma", "Chicken Shawarma"],
    },
  },
};

const productImages = {
  "Pani Puri": "https://images.unsplash.com/photo-1606491956689-2ea866880c84?auto=format&fit=crop&w=800&q=80",
  "Vada Pav": "https://images.unsplash.com/photo-1629531733455-3c5e3be1a8a8?auto=format&fit=crop&w=800&q=80",
  "Pav Bhaji": "https://images.unsplash.com/photo-1631451095765-6c7be420e92b?auto=format&fit=crop&w=800&q=80",
  "Bhel Puri": "https://images.unsplash.com/photo-1667642829290-326ce8c0a9b6?auto=format&fit=crop&w=800&q=80",
  "Chicken Roll": "https://images.unsplash.com/photo-1596797032026-670ba8f2f7e7?auto=format&fit=crop&w=800&q=80",
  "Momos": "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=800&q=80",
  "Idli Vada": "https://images.unsplash.com/photo-1633945274296-2e9d6e2da39f?auto=format&fit=crop&w=800&q=80",
  "Chicken Biryani": "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&w=800&q=80",
  "Aloo Tikki Chaat": "https://images.unsplash.com/photo-1662600006-3e9c3059f2a5?auto=format&fit=crop&w=800&q=80",
  "Kulfi Falooda": "https://images.unsplash.com/photo-1599449733557-6b3c2d3c4f3d?auto=format&fit=crop&w=800&q=80",
  "Masala Dosa": "https://images.unsplash.com/photo-1663431063163-9a7f7a62864d?auto=format&fit=crop&w=800&q=80",
  "Chole Bhature": "https://images.unsplash.com/photo-1702482658922-11d9f71d9d91?auto=format&fit=crop&w=800&q=80",
};

const defaultBackground = "https://images.unsplash.com/photo-1541014741259-de9d9af6e850?auto=format&fit=crop&w=1600&q=80";

const stallsData = {
  "Pani Puri": [
    { name: "Elco Famous Pani Puri", rating: 4.8, reviews: 1345, priceRange: "₹60-80 / plate", offer: true, verified: true },
    { name: "Guru Kripa Chaat", rating: 4.7, reviews: 987, priceRange: "₹70 / plate", offer: false, verified: true },
    { name: "Sindh Pani Puri Wala", rating: 4.9, reviews: 2100, priceRange: "₹50 / plate", offer: true, verified: false },
  ],
  "Vada Pav": [
    { name: "Ashok Vada Pav", rating: 4.8, reviews: 1800, priceRange: "₹30-50 / piece", offer: false, verified: true },
    { name: "Gajanan Vada Pav", rating: 4.6, reviews: 1200, priceRange: "₹25-40", offer: true, verified: true },
    { name: "Jumbo Vada Pav King", rating: 4.5, reviews: 1500, priceRange: "₹50-80", offer: true, verified: true },
  ],
  "Pav Bhaji": [
    { name: "Sardar Pav Bhaji", rating: 4.9, reviews: 2500, priceRange: "₹150-200 / plate", offer: false, verified: true },
    { name: "Amar Pav Bhaji", rating: 4.7, reviews: 1100, priceRange: "₹120-180 / plate", offer: true, verified: true },
  ],
  "Chicken Biryani": [
    { name: "Street Biryani Master", rating: 4.6, reviews: 890, priceRange: "₹250-350 / plate", offer: true, verified: false },
    { name: "Lucky Non-Veg Corner", rating: 4.8, reviews: 1200, priceRange: "₹300 / plate", offer: false, verified: true },
  ],
  "Momos": [
    { name: "Dolma Aunty Momos", rating: 4.9, reviews: 2100, priceRange: "₹100-150 / plate", offer: false, verified: true },
    { name: "Wow Momo Stall", rating: 4.5, reviews: 1800, priceRange: "₹120-180", offer: true, verified: true },
  ],
  "Bhel Puri": [
    { name: "Beach Bhel Wala", rating: 4.7, reviews: 1100, priceRange: "₹50-80 / plate", offer: true, verified: false },
    { name: "Chaat Chowk", rating: 4.8, reviews: 950, priceRange: "₹60 / plate", offer: false, verified: true },
  ],
};

const renderStars = (rating) => {
  const integerPart = Math.floor(rating);
  const hasHalf = rating - integerPart >= 0.5;

  return (
    <div className="flex items-center">
      {[...Array(5)].map((_, i) => (
        <FontAwesomeIcon
          key={i}
          icon={i < integerPart ? faStar : i === integerPart && hasHalf ? faStarHalfAlt : faStar}
          className={i < integerPart || (i === integerPart && hasHalf) ? "text-blue-400" : "text-gray-600"}
          size="sm"
        />
      ))}
    </div>
  );
};

const getFoodTypeLabel = (type) => {
  const labels = {
    "Any": "🍲 Any",
    "Vegetarian": "🥬 Vegetarian",
    "Non-Vegetarian": "🍗 Non-Vegetarian",
    "Jain": "🕉️ Jain",
    "Veg & Non-Veg": "🥗 Veg & Non-Veg",
  };
  return labels[type] || type;
};

const getDiningLabel = (type) => {
  const labels = {
    "Street Food Stall": "🏪 Street Stall",
    "Food Cart": "🚚 Food Cart",
    "Food Truck": "🚛 Food Truck",
    "QSR": "🍔 QSR",
    "Cafe": "☕ Cafe",
    "Fine-Dine": "🍽️ Fine-Dine",
    "Take Away": "📦 Take Away",
    "Home Delivery": "🏠 Delivery",
  };
  return labels[type] || type;
};

const getSpecialLabel = (feature) => {
  const labels = {
    "Current Discounts": "🔥 Discounts",
    "Combo Meals": "📦 Combos",
    "Breakfast": "🌅 Breakfast",
    "Lunch/Dinner": "🥪 Lunch/Dinner",
    "Brunch": "🥞 Brunch",
    "Late Night Snacks": "🌙 Late Night",
    "Family Packs": "👨‍👩‍👧‍👦 Family Packs",
    "Desserts": "🍧 Desserts",
  };
  return labels[feature] || feature;
};

const KhauGaliMetaverseMarketplace = () => {
  const [foodPreference, setFoodPreference] = useState("");
  const [diningFormat, setDiningFormat] = useState("");
  const [specialFeature, setSpecialFeature] = useState("");
  const [selectedDish, setSelectedDish] = useState("");
  const [stallSearch, setStallSearch] = useState("");
  const [sortBy, setSortBy] = useState("ratingDesc");

  const availableDiningFormats = foodPreference ? Object.keys(marketplaceData[foodPreference] || {}) : [];
  const availableSpecialFeatures = foodPreference && diningFormat ? Object.keys(marketplaceData[foodPreference][diningFormat] || {}) : [];
  const availableDishes = foodPreference && diningFormat && specialFeature ? marketplaceData[foodPreference][diningFormat][specialFeature] : [];
  const stalls = selectedDish ? stallsData[selectedDish] || [] : [];

  let displayedStalls = [...stalls];

  if (stallSearch) {
    displayedStalls = displayedStalls.filter((s) =>
      s.name.toLowerCase().includes(stallSearch.toLowerCase())
    );
  }

  if (sortBy === "ratingDesc") {
    displayedStalls.sort((a, b) => b.rating - a.rating);
  } else if (sortBy === "ratingAsc") {
    displayedStalls.sort((a, b) => a.rating - b.rating);
  } else if (sortBy === "name") {
    displayedStalls.sort((a, b) => a.name.localeCompare(b.name));
  }

  const averageRating =
    displayedStalls.length > 0
      ? (displayedStalls.reduce((sum, s) => sum + s.rating, 0) / displayedStalls.length).toFixed(1)
      : 0;
  const totalReviews = displayedStalls.reduce((sum, s) => sum + s.reviews, 0);

  return (
    <div className="min-h-screen bg-black text-blue-300">
      <div className="w-full max-w-7xl mx-auto px-4 py-4">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
          <h2 className="text-lg lg:text-xl font-extrabold text-blue-400 mb-4 flex items-center justify-center gap-4">
            <FontAwesomeIcon icon={faBowlRice} /> Khau Gali Metaverse
          </h2>
          <p className="text-sm lg:text-lg text-blue-200 max-w-4xl mx-auto">
            Dive into India's vibrant street food scene! Discover iconic dishes, hot offers, combos, and legendary stalls.
          </p>
        </motion.div>

        {/* Mobile-first responsive filter grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-2 bg-black rounded-lg p-2 shadow-2xl">
          <select
            className={`w-full bg-gray-900 border border-blue-900 p-4 rounded-md 
              text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600
              ${foodPreference ? 'text-white' : 'text-gray-100'}`}
            value={foodPreference}
            onChange={(e) => {
              setFoodPreference(e.target.value);
              setDiningFormat("");
              setSpecialFeature("");
              setSelectedDish("");
            }}
          >
            <option value="" disabled>
              Food Preference
            </option>

            {["Any", "Vegetarian", "Non-Vegetarian", "Jain", "Veg & Non-Veg"].map((type) => (
              <option key={type} value={type}>
                {getFoodTypeLabel(type)}
              </option>
            ))}
          </select>

          <select
            className="w-full bg-gray-800 border border-blue-900 p-4 rounded-md text-blue-100 focus:ring-4 focus:ring-blue-600 focus:outline-none"
            value={diningFormat}
            onChange={(e) => {
              setDiningFormat(e.target.value);
              setSpecialFeature("");
              setSelectedDish("");
            }}
            disabled={!foodPreference}
          >
            <option value="" className="bg-gray-800 text-white">Dining Format</option>
            {availableDiningFormats.map((df) => (
              <option key={df} value={df} className="bg-gray-800">{getDiningLabel(df)}</option>
            ))}
          </select>

          <select
            className="w-full bg-gray-800 border border-blue-900 p-4 rounded-md text-blue-100 focus:ring-4 focus:ring-blue-600 focus:outline-none"
            value={specialFeature}
            onChange={(e) => {
              setSpecialFeature(e.target.value);
              setSelectedDish("");
            }}
            disabled={!diningFormat}
          >
            <option value="" className="bg-gray-800 text-white">Special / Meal Time</option>
            {availableSpecialFeatures.map((sf) => (
              <option key={sf} value={sf} className="bg-gray-800">{getSpecialLabel(sf)}</option>
            ))}
          </select>

          <select
            className="w-full bg-gray-800 border border-blue-900 p-4 rounded-md text-blue-100 focus:ring-4 focus:ring-blue-600 focus:outline-none"
            value={selectedDish}
            onChange={(e) => setSelectedDish(e.target.value)}
            disabled={!specialFeature}
          >
            <option value="" className="bg-gray-800 text-white">Select Dish</option>
            {availableDishes.map((dish) => (
              <option key={dish} value={dish} className="bg-gray-800">{dish}</option>
            ))}
          </select>
        </div>

        {/* Dish Showcase */}
        {selectedDish ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="relative w-full rounded-lg shadow-lg overflow-hidden"
          >
            <img
              src={productImages[selectedDish] || defaultBackground}
              alt={selectedDish}
              className="w-full h-96 lg:h-[600px] object-cover brightness-50"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent flex flex-col">
              <h3 className="text-center text-lg lg:text-xl font-bold text-blue-300 mt-2 drop-shadow-2xl px-4">
                {selectedDish} — {getDiningLabel(diningFormat)} ({getSpecialLabel(specialFeature)})
              </h3>

              {/* Search & Sort */}
              {stalls.length > 0 && (
                <div className="px-4 mt-2 flex flex-col lg:flex-row gap-4 items-center justify-between">
                  <div className="text-blue-200 text-sm lg:text-lg">
                    Avg Rating: <span className="font-bold text-lg lg:text-xl text-blue-400">{averageRating} ⭐</span> ({totalReviews} reviews)
                  </div>

                  <div className="flex flex-col lg:flex-row gap-4 w-full lg:w-auto">
                    <input
                      type="text"
                      placeholder="Search stalls..."
                      value={stallSearch}
                      onChange={(e) => setStallSearch(e.target.value)}
                      className="w-full px-4 py-3 rounded-md bg-gray-800/90 text-blue-100 placeholder-blue-400 border border-blue-900 focus:outline-none focus:ring-4 focus:ring-blue-600"
                    />

                    <select
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                      className="px-4 py-3 rounded-md bg-gray-800/90 text-blue-100 border border-blue-900"
                    >
                      <option value="ratingDesc" className="bg-gray-800">Rating: High → Low</option>
                      <option value="ratingAsc" className="bg-gray-800">Rating: Low → High</option>
                      <option value="name" className="bg-gray-800">Name: A-Z</option>
                    </select>
                  </div>
                </div>
              )}

              {/* Stalls Grid - Mobile First */}
              <div className="flex-1 p-4 grid grid-cols-2 lg:grid-cols-3 gap-4 overflow-y-auto">
                {displayedStalls.length > 0 ? (
                  displayedStalls.map((stall, index) => (
                    <motion.div
                      key={stall.name}
                      initial={{ opacity: 0, y: 40 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.1 }}
                      whileHover={{ scale: 1.05, y: -8 }}
                      className="bg-gray-900/95 border border-blue-900 rounded-lg p-5 shadow-2xl flex flex-col justify-between relative overflow-hidden"
                    >
                      {stall.verified && (
                        <div className="absolute top-3 left-3 bg-blue-600 text-white px-3 py-1 rounded-md flex items-center gap-1 text-xs lg:text-sm font-bold">
                          <FontAwesomeIcon icon={faCheckCircle} /> Verified
                        </div>
                      )}

                      {stall.offer && (
                        <div className="absolute -top-1 -right-1 bg-cyan-600 text-white px-3 py-2 rounded-bl-lg font-bold animate-pulse flex items-center gap-2 text-sm">
                          <FontAwesomeIcon icon={faTag} /> Offer!
                        </div>
                      )}

                      <div>
                        <h4 className="font-bold text-lg lg:text-xl text-blue-300 mb-3">{stall.name}</h4>
                        <div className="mb-3">
                          {renderStars(stall.rating)}
                          <span className="ml-3 text-xs lg:text-sm text-blue-200">({stall.reviews} reviews)</span>
                        </div>
                        <p className="text-blue-100 font-bold text-sm lg:text-lg">{stall.priceRange}</p>
                      </div>

                      <Link
                        to="/twiworld"
                        state={{ stall: stall.name, dish: selectedDish, format: diningFormat, special: specialFeature, stallData: stall }}
                        className="mt-2 bg-blue-600 text-white font-bold py-2 rounded-lg text-center hover:bg-blue-700 transition shadow-md"
                      >
                        Explore Stall
                      </Link>
                    </motion.div>
                  ))
                ) : (
                  <p className="text-blue-200 text-sm lg:text-lg text-center col-span-full drop-shadow-2xl py-12">
                    {stallSearch ? "No matching stalls found" : "New stalls coming soon! Try other filters 🍴"}
                  </p>
                )}
              </div>
            </div>
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-8 bg-gray-900/80 rounded-md shadow-inner"
          >
            <img src={defaultBackground} alt="Khau Gali" className="w-full max-w-lg mx-auto rounded-lg shadow-lg mb-8 opacity-80" />
            <p className="text-lg lg:text-xl text-blue-300 font-bold px-4">
              Select filters to discover legendary Khau Gali stalls & dishes! 🔥🍲
            </p>
            <p className="text-xl lg:text-2xl mt-8">🌶️🥙🍧</p>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default KhauGaliMetaverseMarketplace;